module.exports = __webpack_public_path__ + "static/media/cedar.6d4cdc5c.jpg";